<div class='pros-image-cropper-component' style='width:100%;height:100%'></div>